import React, { FC } from 'react';
import { FlatEntry } from 'services/cms/flattenContentful';
import { LinkVariant, NavigationItem } from 'api/contentful/contentTypes.cloverdotcom';
import { SproutButton } from 'components/Button/SproutButton';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import { CustomIconLink } from 'components/ContentLinkV2/CustomIconLink';
import { t } from 'i18next';
import { useLocation } from 'react-router-dom';

export interface INavConditionalItemsProps {
  items: FlatEntry<NavigationItem>[];
  className: string;
  isMobile?: boolean;
  isSubNavDrawerOpen?: boolean;
}

export const NavConditionalItems: FC<INavConditionalItemsProps> = ({
  items,
  className,
  isMobile = false,
  isSubNavDrawerOpen = false,
}) => {
  const { pathname } = useLocation();
  const isByoRoute = pathname.includes('/build-your-own');

  if (!items.length) return null;

  const renderSproutButton = (item: FlatEntry<NavigationItem>, index: number) => (
    <SproutButton
      key={componentKeyV2(item, index)}
      className={className}
      size="small"
      variant={LinkVariant.PRIMARY}
    >
      <a href={t('navbar-util-menu.byo-phone.link')}>{t('navbar-util-menu.byo-phone.number')}</a>
    </SproutButton>
  );

  const renderButtonLink = (item: FlatEntry<NavigationItem>, index: number) => (
    <ButtonLinkV2 key={componentKeyV2(item, index)} entry={item} className={className} size="small" />
  );

  const renderMobileLink = (item: FlatEntry<NavigationItem>, index: number) => (
    <a key={componentKeyV2(item, index)} className={className} href={t('navbar-util-menu.byo-phone.link')}>
      {t('navbar-util-menu.byo-phone.number')}
    </a>
  );

  const renderCustomIconLink = (item: FlatEntry<NavigationItem>, index: number) => (
    <CustomIconLink
      key={componentKeyV2(item, index)}
      entry={item}
      className={className}
      disabled={isSubNavDrawerOpen}
      tabIndex={isSubNavDrawerOpen ? -1 : 0}
    />
  );

  const renderConditionalNavItem = (item: FlatEntry<NavigationItem>, index: number) => {
    if (!isMobile) {
      return isByoRoute && item.title === t('contact-sales')
        ? renderSproutButton(item, index)
        : renderButtonLink(item, index);
    } else {
      return isByoRoute && item.title === t('contact-sales')
        ? renderMobileLink(item, index)
        : renderCustomIconLink(item, index);
    }
  };

  return <>{items.map(renderConditionalNavItem)}</>;
};
